import axios from "axios";
import { getToken, getTokenHeader } from "../../../Common/Token";
import { dealerCompanyBaseProductPriceUrl } from "../urls";

export const CompaniesBaseProductPrice = async (id, useresiId) => {
  return new Promise(async next => {
    let token = await getToken();
    await axios
      .get(`${dealerCompanyBaseProductPriceUrl()}?company_id=${id}&user_esi_id=${useresiId}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({data}) => {
        return next(data);
      })
      .catch((err) => {
        return next({
          error: true,
          message: err.response?.data?.message || err.message,
        });
      });
  });
};